import React from 'react';
import PropTypes from 'prop-types';

function ListSelectionBanner({
  allEntityIds,
  isAllSelected,
  isAllPageOnlySelected,
  clearSelected,
  selected,
  handleSelectAll,
}) {
  if (isAllPageOnlySelected) {
    return (
      <div className="alert alert-secondary text-center" role="alert">
        {`All ${selected.length} items on this page are selected.`}
        <button
          type="button"
          className="btn btn-link pt-0"
          onClick={handleSelectAll}
        >
          {`Select all ${allEntityIds.length} in this list`}
        </button>
      </div>
    );
  }
  if (isAllSelected) {
    return (
      <div className="alert alert-secondary text-center" role="alert">
        {`All ${allEntityIds.length} items in this list are selected.`}
        <button
          type="button"
          className="btn btn-link"
          onClick={clearSelected}
        >
          Clear Selection
        </button>
      </div>
    );
  }
  return <></>;
}

ListSelectionBanner.propTypes = {
  allEntityIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  isAllSelected: PropTypes.bool.isRequired,
  isAllPageOnlySelected: PropTypes.bool.isRequired,
  clearSelected: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleSelectAll: PropTypes.func.isRequired,
};
export default ListSelectionBanner;
